<template>
    <div>
        <template v-for="(tag) in value">
            <a-tag
                :key="tag"
                :closable="value.length != 1"
                :afterClose="() => handleTagClose(tag)"
            >
                {{ tag }}
            </a-tag>
        </template>
        <a-input
            v-if="tagInputVisible"
            ref="tagInput"
            type="text"
            size="small"
            :style="{ width: '78px' }"
            :value="tagInputValue"
            @change="handleInputChange"
            @blur="handleTagInputConfirm"
            @keyup.enter="handleTagInputConfirm"
            />
        <a-tag v-else @click="showTagInput" style="background: #fff; borderStyle: dashed;">
            <a-icon type="plus"/>新增  
        </a-tag>
    </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: Array
    }
  },
  model: {
    prop: 'value',
    event: 'returnBack'
  },
  data () {
    return {
        tagInputVisible: false,
        tagInputValue: ''
    }
  },
  methods: {
    handleTabChange (key, type) {
      this[type] = key
    },

    handleTagClose (removeTag) {
      const tags = this.value.filter(tag => tag !== removeTag)
      this.$emit('returnBack',tags)
      this.triggerChange(tags)
    },

    showTagInput () {
      this.tagInputVisible = true
      this.$nextTick(() => {
        this.$refs.tagInput.focus()
      })
    },

    handleInputChange (e) {
      this.tagInputValue = e.target.value
    },

    handleTagInputConfirm () {
      const inputValue = this.tagInputValue
      let tags = this.value
      if (inputValue && !tags.includes(inputValue)) {
        tags = [...tags, inputValue]
      }
      Object.assign(this, {
        tagInputVisible: false,
        tagInputValue: ''
      })
      this.triggerChange(tags)
      this.$emit('returnBack',tags)
    },
    triggerChange  (changedValue) {
      // Should provide an event to pass value to Form.
      this.$emit('change', changedValue);
    }
  }
}
</script>

<style lang="less" scoped>
.ant-tag {
  margin-bottom: 8px;
}
</style>
